function mountBillboardContent (template, container) {
  if (!template || !template.content || !container) {
    return false
  }

  container.appendChild(template.content.cloneNode(true))
  return true
}

module.exports = { mountBillboardContent }
